<script>
    import { handleScoopAjaxError } from '../../../../resources/js/mixins/axios-response-errors'

    export default {
        props: {
            package: {
                type: Object,
                default: null
            },
            sharedUser: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                baseUrl: Scoop.baseUrl,
            }
        },
        methods: {
            removeUserShare(id) {
                axios.delete(Scoop.baseUrl + '/mediaserver/packages/'+this.package.id+'/shareuser/'+id)
                    .then(response => {
                        this.$emit('packageChanged', response.data);
                    })
                    .catch(error => handleScoopAjaxError(error, 'Could not remove user'));
            },
            setIsAdmin(sharedUser) {
                axios.patch(Scoop.baseUrl + '/mediaserver/packages/'+this.package.id+'/shareuser/'+sharedUser.id, {
                    'is_admin': !sharedUser.is_admin
                })
                    .then(response => {
                        this.$emit('packageChanged', response.data);
                    })
                    .catch(error => handleScoopAjaxError(error, 'Could not update user'));
            },
        },
    }
</script>
<template>
    <div class="package-share-users">
        <div style="border: 1px solid #F0F0F0; padding: 7px;">
            <a href="#" class="pull-left m-r-sm">
                <img alt="image" class="img-circle"
                     :src="sharedUser.user ? sharedUser.user.avatarUrl : baseUrl + '/img/vendor/scoop-os/default-avatar.png'"
                     width="35" height="35">
            </a>
            <span v-if="sharedUser.is_admin" class="label label-primary m-r-xs">
                Admin
            </span>
            <a v-if="package.current_user_is_admin" title="Unshare" @click="removeUserShare(sharedUser.id)" class="pull-right">
                <i class="fa fa-trash" aria-hidden="true"></i>
            </a>
            <div v-if="package.current_user_is_admin" class="inline dropdown show pull-right">
                <a href="#" class="p-xs dropdown-toggle" role="button" :id="'useroptions'+sharedUser.id" data-toggle="dropdown">
                    <i class="fa fa-caret-down" aria-hidden="true"></i>
                </a>
                <ul class="dropdown-menu" :aria-labelledby="'useroptions'+sharedUser.id">
                    <li class="dropdown-item">
                        <a @click="setIsAdmin(sharedUser)"
                           class="m-t-none"
                           v-text="sharedUser.is_admin ? 'Revoke admin permission' : 'Grant admin permission'"
                        >
                        </a>
                    </li>
                </ul>
            </div>
            <template v-if="sharedUser.user">
                <strong v-text="sharedUser.user.fullName"></strong>
                <p class="m-b-xs" v-text="sharedUser.user.email"></p>
            </template>
            <template v-else>
                <strong>User invited</strong>
                <p class="m-b-xs" v-text="sharedUser.email"></p>
            </template>
        </div>
    </div>
</template>
